import React from 'react';

import { useIntl } from 'react-intl';

import { ArrowLink } from 'components/arrow-link';
import { routes } from 'utils/routing';

const CommPreference = () => {
  const { formatMessage } = useIntl();

  return (
    <ArrowLink data-testid="communication-preferences" to={routes.communication}>
      {formatMessage({ id: 'commPrefs' })}
    </ArrowLink>
  );
};

export default CommPreference;
